import { cn } from '@/lib/cn';

type SpinnerProps = {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};

const sizeClass = {
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-[3px]'
};

export function Spinner({ className, size = 'md' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block animate-[fv-spin_0.7s_linear_infinite] rounded-full border-[var(--fv-primary)]/25 border-t-[var(--fv-primary)]',
        sizeClass[size],
        className
      )}
    />
  );
}
